import { render } from "./TeacherSubPageHeading.vue?vue&type=template&id=7a445ab3&ts=true"
import script from "./TeacherSubPageHeading.vue?vue&type=script&lang=ts"
export * from "./TeacherSubPageHeading.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__